import { OctagonAlertIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

export const UploadDocumentHeader = () => {
  return (
    <div>
      <div className={cn('flex items-center gap-x-3.5', 'mb-8', 'p-5', 'rounded-[12px] bg-purple-100')}>
        <OctagonAlertIcon size={24} className={cn('text-purple-700', 'min-w-6')} />
        <p className={cn('text-base')}>
          <span className={cn('font-semibold text-purple-700')}>
            This feature is available to all subscribers through July 31, 2025
          </span>
          <span className={cn('font-medium text-black')}>
            , and will be limited to Premium and Growth plans afterward.
          </span>
        </p>
      </div>
      <p className={cn('text-2xl font-bold text-black')}>Upload Documents (Receipt of Notices or I-797s)</p>
    </div>
  )
}
